<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

    <app-dashboard-navbar></app-dashboard-navbar>

    <!-- Breadcrumb Area -->
    <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item"><a routerLink="/">Home</a></li>
            <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li>
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
    <!-- End Breadcrumb Area -->

    <!-- Start -->
    <div class="add-listings-box1">
        <!-- Start -->
        <!-- End -->


        <div class="vesax-register">
            <form [formGroup]="userRegisterFormControl" (ngSubmit)="registerUser(signup)" #signup="ngForm">
                <div class="row">
                    <div class="col-lg-4 col-md-12">
                        <div class="form-group">
                            <label for="bu-assign">BU Assign<span class="star_class">*</span></label>
                            <select class="form-control form-select" formControlName="bu"
                                [class.is-invalid]="signup.submitted && userRegisterFormControl.get('bu')?.invalid || userRegisterFormControl.get('bu')?.invalid && userRegisterFormControl.get('bu')?.touched"
                                required>
                                <option value="" selected disabled>Select BU Assign</option>
                                <ng-container *ngFor="let item of budata">
                                    <option [value]="item.id">{{item.value}}</option>
                                </ng-container>
                            </select>
                            <div class="invalid-feedback" *ngIf="userRegisterFormControl.get('bu').errors?.required">
                                Please Select BU Assign
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12">
                        <div class="form-group">
                            <label>Assign Checker 2<span class="star_class">*</span></label>

                            <p-multiSelect [options]="checker2list" (onChange)="onDescriptionSelected($event)"
                                [filter]="true" filterBy="itemDesc" [resetFilterOnHide]="true"
                                placeholder="Assign Checker 2" formControlName="checker2" optionValue="loginId"
                                optionLabel="userName" class="custom-dd">

                            </p-multiSelect>
                            <div class="error-msg" *ngIf="signup.submitted &&
                    userRegisterFormControl.get('checker2')?.invalid ||
                    userRegisterFormControl.get('checker2')?.invalid &&
                    userRegisterFormControl.get('checker2')?.touched">Please
                                select Checker 2</div>
                        </div>
                    </div>


                </div>
                <div class="add-listings-btn">
                    <div class="form-group">
                        <button type="submit" class="submit_btn">{{submitButton}}</button>
                        <button type="button" (click)="setActive()" class="reset_btn mx-2">Reset</button>
                    </div>
                </div>
            </form>
        </div>

    </div>

    <div class="add-listings-box1 register-zzz">
        <p-table #dt2 [value]="userArray" dataKey="id" responsiveLayout="scroll" [rows]="10"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]" [paginator]="true"
            currentPageReportTemplate="Showing
            {first} to {last} of {totalRecords} entries"
            [globalFilterFields]="['roleName','userName','mobileNo','loginName','address']">
            <ng-template pTemplate="caption">
                <span class="p-input-icon-left d-flex align-items-center">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value,
                        'contains')" placeholder="Global Search" [(ngModel)]="filterval" />
                    <p-button type="button" class="ml-2" (click)="reset(dt2)" icon="bx bx-reset"></p-button>
                </span>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>S.No.</th>
                    <th>BU Name</th>
                    <th>Assign Checker 2</th>
                    <th>Action</th>
                    <!-- <th>Mobile No</th>
                    <th>User Role</th>
                    <th>User Status</th>
                    <th>Checker1</th>
                    <th>Checker2</th>
                    <th>Address</th>
                    <th>Action</th> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer let-i="rowIndex">
                <tr>
                    <td>{{i+1}}</td>
                    <td><span>{{customer.buName}}</span></td>
                    <td>
                        <span>{{customer.checker2Names}}</span>
                    </td>
                    <td>
                        <button pButton pRipple type="button" icon="bx bx-trash"
                            class="p-button-rounded p-button-danger p-button-text"
                            (click)="confirm1(customer.buMasterId)"></button>
                    </td>
                    <!-- <td>
                            <span class="image-text">{{customer.mobileNo}}</span>
                        </td>
                        <td>
                            <span class="image-text">{{customer.roleName}}</span>
                        </td>
                        <td>
                            <span class="image-text">{{customer.isActive ? 'Active' : 'Inactive'}}</span>
                        </td>
                        <td>
                            <button pButton pRipple type="button" icon="bx bx-check-circle" *ngIf="customer.checker1"
                                class="p-button-rounded p-button-success p-button-text"></button>
                            <button pButton pRipple type="button" icon="pi pi-times-circle" *ngIf="!customer.checker1"
                                class="p-button-rounded p-button-danger p-button-text"></button>
                        </td>
                        <td>
                            <button pButton pRipple type="button" icon="bx bx-check-circle" *ngIf="customer.checker2"
                                class="p-button-rounded p-button-success p-button-text"></button>
                            <button pButton pRipple type="button" icon="pi pi-times-circle" *ngIf="!customer.checker2"
                                class="p-button-rounded p-button-danger p-button-text"></button>
                        </td>
                        <td>
                            <span class="image-text">{{customer.address}}</span>
                        </td>
                        <td>
                            <button pButton pRipple type="button" icon="bx bx-pencil"
                                class="p-button-rounded p-button-primary p-button-text"
                                (click)="EditItem(customer)"></button>
                        </td> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5">No item found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <!-- End -->
    <app-copyrights></app-copyrights>
</div>